import React from 'react';
import { SolutionStandard } from '../../layouts/SolutionStandard';

const Page = (location) => <SolutionStandard {...location} />;
export default Page;
